<template>
    <div class="unlineContent">
        <main-content :proObj='proObj'></main-content>
    </div>
</template>

<script>
import mainContent from './commom/mainContent';
import { searchProOffline } from '../../../../api/productProcess.js';
import { proObj } from './js/unLine.js';
export default {
    props: {
    },
    components: {
        mainContent
    },
    data () {
        return {
            proNum: '',
            flag: false,
            proObj
        };
    },
    methods: {
        handleClick(tab, event) {
        },
        initData() {
            this.proObj['list'].forEach(item => {
                item.value = '';
            });
        },
        setproNum(proNum) {
            this.initData();
            this.proNum = proNum;
            this.flag = true;
        },
        // 获取成品下线详细信息
        getMessage() {
            if (this.flag) {
                searchProOffline(this.proNum).then(res => {
                    if (res.code === '0' && res.data) {
                        const obj = res.data;
                        const arr = Object.keys(obj);
                        this.proObj['list'].forEach(item => {
                            arr.map(item2 => {
                                if (item.key === item2) {
                                    item.value = obj[item2];
                                }
                            });
                        });
                    }
                });
                this.flag = false;
            }
        }
    }
};
</script>
<style lang="less">
</style>